<template>
  <div class="portal">
    <!-- <div class="open-menu">
      <font-awesome-icon icon="bars" />
    </div> -->
    <div class="container-fluid">
      <b-modal id="AlertModal"
        class="modal-size-alert"
        :style="modalStyle"
        v-model="alertModalShow"
        size="lg"
        centered
        hide-footer>
        <img class="rwd" :src="getImageSrc('timeline_20200107_210945.jpg')" />>
      </b-modal>
      <div class="row">
        <div class="col-12 top-block-container">
          <block-with-top-menu></block-with-top-menu>
        </div>
      </div>
    </div>
    <div class="container" id="stage-top">
      <div class="row">
        <div class="col-12">
          <series-list></series-list>
        </div>
      </div>
      <b-row id="course-apply">
        <b-col>
          <a href="https://reurl.cc/4eG23" target="_apply">
            <div class="sprite">
              <div class="sprite-BANNER01_mobile" v-if="getIsMobile == true"></div>
              <div class="sprite-BANNER01" v-if="getIsMobile == false"></div>
            </div>
          </a>
        </b-col>
      </b-row>
      <div id="about-project" name="about-project" class="row no-gutters">
        <div class="col-12 col-md-12 hide-in-mobile">
          <div class="sprite">
            <img v-if="false" :src="sprite_image_src" class="sprite-images_SI" />
            <div class="sprite-images_SI"></div>
          </div>
        </div>
        <div class="col-12 col-md-12 hide-not-mobile">
          <div class="sprite">
            <img v-if="false" :src="sprite_image_src" class="sprite-images_mSI" />
            <div class="sprite-images_mSI"></div>
          </div>
        </div>
      </div>
      <div id="about-team" name="about-team"></div>
      <div class="row no-gutters as-background hide-in-mobile" v-if="getIsMobile == false">
        <div class="col-12 col-md-12">
          <div class="sprite">
            <img v-if="false" :src="sprite_image_src" class="sprite-images_PT" />
            <div id="about-team-image" class="sprite-images_PT"></div>
            <div id="principal-container"
              v-if="false"
              class="pointer"
              z-v-follow="this['about-team-params']"
              @click="playPrincipalVideo()">
              <div id="principal" class="sprite">
                <img v-if="false" :src="sprite_image_src" class="sprite-principal" />
                <div class="sprite-principal sprite-principal-absolute"></div>
              </div>
            </div>
            <video-js ref="video-principal"></video-js>
          </div>
        </div>
      </div>
      <div class="row no-gutters as-background hide-not-mobile" v-if="getIsMobile == true">
        <div class="col-12 col-md-12">
          <div class="sprite">
            <img v-if="false" :src="sprite_image_src" class="sprite-images_mPT-rwd" />
            <div class="sprite-images_mPT"></div>
          </div>
        </div>
      </div>
      <!-- <div class="row no-gutters footer justify-content-center">
        <div class="col-10">
          <div class="row justify-content-center">
            <div class="col-8 col-lg-4 text-center justify-content-center align-self-center">
              <div class="sprite sprite-logo-max sprite-center text-center">
                <div class="sprite-logo"></div>
              </div>
            </div>
            <div class="col-8">
              <div class="infos d-flex flex-column">
                <div class="p-2">TEL： +886-2-2700-5858</div>
                <div class="p-2">Address：No.16, Ln. 276, Rui’an St., Da’an Dist., Taipei City 10661, Taiwan (R.O.C.)</div>
                <div class="p-2">Copyright &copy; 2019 中國文化大學 Chinese Culture University. All Rights Reserved.</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="false" class="col-6 col-sm-8 col-md-10 col-lg-8 col-xl-3 justify-content-center text-center">
          <div class="sprite">
            <div class="sprite-logo"></div>
          </div>
        </div>
        <div v-if="false" class="col-10 col-sm-10 col-md-10 col-lg-8 col-xl-6 justify-content-center">
          <div class="infos">
            <p>TEL： +886-2-2700-5858</p>
            <p>Address：No.16, Ln. 276, Rui’an St., Da’an Dist., Taipei City 10661, Taiwan (R.O.C.)</p>
            <p>Copyright &copy; 2019 中國文化大學 Chinese Culture University. All Rights Reserved.</p>
          </div>
        </div>
      </div> -->
      <page-footer></page-footer>
      <div id="scrollToTop" class="scroll-top">
        <!-- <div class="sprite-TOP"></div> -->
        <font-awesome-icon icon="caret-up" />
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters, mapActions,
  } from 'vuex'
  import Components from '../components'
  import { globalMixin, platformMixin, courseMixin, imageMixin, GuardMixin } from '../components/_Mixins'
  import VideoJS from '@/components/VideoJS'
  import Footer from '@/components/Footer'

  import $ from 'jquery'

  export default {
    data() {
      return {
        'alertModalShow': false,
        'modalStyle': {
            "z-index": 65535,
            "width": 619 + "px",
        },
        'about-team-params':
          {
            target: '#about-team-image',
            ref_width: 1280,
            ref_height: 1315,
            target_x: 572,
            target_y: 110,
            // firefox: {
            //   target_y: 102,
            // },
            el_width: 135,
            el_height: 158,
            // modalStyle: {
            //   "z-index": 65535,
            //   "width": 619 + "px",
            // }
          }
      }
    },
    mounted() {
      console.log('Portal.vue',
        'mounted !!')

      let _this = this

      let windowScroll = () => {
        console.log('[Portal.vue]',
          '#169 windowScroll',
          'document.documentElement.scrollTop',
          document.documentElement.scrollTop)
      }

      let detectSeriesesReady = (times = 300) => {
        console.log('[Portal.vue]',
          '#169 detectSeriesesReady',
          'this.Serieses',
          this.Serieses,
          'seriesesInState',
          this.seriesesInState)

        times -= 1

        if (times > 0) {
          setTimeout(function() {
            detectSeriesesReady(times)
          }, 200)
        }
      }

      //$(window).on('scroll', windowScroll)
      // $(function() {
      //   $(window).scroll(windowScroll)
      // })

      setTimeout(() => {
        let body = document.querySelector("body")

        // console.log(body)
        // console.log(this.getMainColor)
        // document.querySelector("body").classList.remove('course')
        // document.querySelector("body").classList.remove('font-jp')
        document.querySelector("body").className = ''

        document.querySelector("body").style.backgroundColor = ''

        //_this.doPlatformAndMobileDetect()
      }, 100)

      // setTimeout(detectSeriesesReady)
    },

    components: {
      BlockWithTopMenu: Components.VueBlockWithTopMenu,
      SeriesList: Components.VueSeriesList,
      'video-js': VideoJS,
      'page-footer': Footer,
    },

    mixins: [ globalMixin, platformMixin, courseMixin, imageMixin, GuardMixin ],

    methods: {

      getAlertShowed(key, defaultValue) {
        try {
            let value = window.sessionStorage.getItem(key)

            //console.log('>>>> Portal.vue > getAlertShowed > value : ', value)

            return value || defaultValue
        }
        catch (ex) {
            console.error(ex)

            return defaultValue
        }
      },

      setAlertShowed() {
        window.sessionStorage.setItem('alert-showed', true)
      },

      playPrincipalVideo() {
        let src = '/portal/0617_v2.mp4'
        this.$refs['video-principal'].play(this.combineFullResourceUrl(src))
      }
    },

    computed: {
        IsAlertShowed() {
            //console.log('>>> Portal.vue > this', this)
            return this.getAlertShowed('alert-showed') || false
        }
    },

    watch: {
      '$route': function (to, from) {
        // console.log('watch', to, from, to.path, this.$router)
        this.$router.go({
          path: to.path,
          force: true,
        })
      },
    },
  }

</script>



// WEBPACK FOOTER //
// src/views/Portal.vue